import { css } from '@emotion/react';
export const klarnaPanel = css `
    border: none;
    width: 100%;
    min-height: 600px;
@media only screen and (width <= 600px) {
        min-height: 800px;
  }

`;
export const klarnaPanelContainer = {
    width: '100%',
};
export const trackingImage = css `
display:none;
`;
